<template>
  <div class="blocking-block w-full" :data-block-field-id="answerKey({field_id})">
    <div class="overflow" :class="{hidden: initHidden}" />
    <div>
      <slot />
    </div>
  </div>
</template>
<script>
import {answerKey} from '../../stores/form_result';

export default{
  props: {
    field_id: {type: Number, required: true},
    initHidden: {type: Boolean, default: true},
    zIndex: {type: Number, default: 99},
  },
  data: ()=>({
    answerKey,
  }),
}
</script>
<style scoped>
.blocking-block{
  position: relative;
}
.overflow{
  width: 100%;
  height: 100%;
  position: absolute;
  background: #ccc;
  opacity: 50%;
  z-index: v-bind('zIndex');
}
</style>